import { memo } from 'react'

import { cn } from '../../../../lib/utils'

export const MINI_WAVEFORM_BAR_HEIGHTS = [4, 7, 11, 6, 9, 14, 8, 5, 10, 6]

export interface MiniWaveformProps {
  className?: string
  barClassName?: string
  barHeights?: readonly number[]
}

export const MiniWaveform = memo(function MiniWaveform({
  className,
  barClassName,
  barHeights = MINI_WAVEFORM_BAR_HEIGHTS,
}: MiniWaveformProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('flex h-4 items-center justify-center gap-0.5', className)}
      data-testid="mini-waveform"
    >
      {barHeights.map((height, index) => (
        <span
          key={index}
          className={cn('w-0.5 rounded-full bg-primary/70', barClassName)}
          style={{ height }}
        />
      ))}
    </span>
  )
})
